<script lang="ts" setup>
	import type {HTMLAttributes} from 'vue';
	import {useFormField} from './useFormField';
	import Description from '@/components/ui/description/Description.vue';

	const props = defineProps<{
		class?: HTMLAttributes['class'];
	}>();

	const {formDescriptionId} = useFormField();
</script>

<template>
	<Description
		:id="formDescriptionId"
		:class="props.class"
	>
		<slot />
	</Description>
</template>
